export const info = {
  apiUrl: "https://tokengeneratoradmin.uncw3b.com/",
};
